export type Hours = {
  day: 1 | 2 | 3 | 4 | 5 | 6 | 7; // 1 == Monday
  open: number;
  close: number;
};

export type Metric = {
  id: string;
  value: string;
};
